import type { FeatureSet } from '@/@core/models/FeatureFlags';
import { z } from 'zod';

export const FEATURE_SET_SCHEMA = z.object({
  feature_set: z.string() as z.ZodType<FeatureSet>,
});

export type FeatureSetResponse = z.infer<typeof FEATURE_SET_SCHEMA>;
